import { render, staticRenderFns } from "./RestaurantSettings.vue?vue&type=template&id=77ad0a5f&scoped=true"
import script from "./RestaurantSettings.vue?vue&type=script&lang=js"
export * from "./RestaurantSettings.vue?vue&type=script&lang=js"
import style0 from "./RestaurantSettings.vue?vue&type=style&index=0&id=77ad0a5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ad0a5f",
  null
  
)

export default component.exports